// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BulkAddItemCostCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BulkAddItemCostCodesQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', fullCode: string, displayName: string, id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> };

export type BulkAddItemCostCodes_ItemFragment = { __typename?: 'Item', fullCode: string, displayName: string, id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } };

export const BulkAddItemCostCodes_ItemFragmentDoc = gql`
    fragment BulkAddItemCostCodes_Item on Item {
  ...Named
  fullCode
  displayName
  costCode {
    id
    displayName
  }
}
    ${NamedFragmentDoc}`;
export const BulkAddItemCostCodesDocument = gql`
    query BulkAddItemCostCodes {
  items(filter: {status: [ACTIVE]}) {
    ...BulkAddItemCostCodes_Item
  }
}
    ${BulkAddItemCostCodes_ItemFragmentDoc}`;

/**
 * __useBulkAddItemCostCodesQuery__
 *
 * To run a query within a React component, call `useBulkAddItemCostCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkAddItemCostCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkAddItemCostCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBulkAddItemCostCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>(BulkAddItemCostCodesDocument, options);
      }
export function useBulkAddItemCostCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>(BulkAddItemCostCodesDocument, options);
        }
// @ts-ignore
export function useBulkAddItemCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>;
export function useBulkAddItemCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BulkAddItemCostCodesQuery | undefined, BulkAddItemCostCodesQueryVariables>;
export function useBulkAddItemCostCodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>(BulkAddItemCostCodesDocument, options);
        }
export type BulkAddItemCostCodesQueryHookResult = ReturnType<typeof useBulkAddItemCostCodesQuery>;
export type BulkAddItemCostCodesLazyQueryHookResult = ReturnType<typeof useBulkAddItemCostCodesLazyQuery>;
export type BulkAddItemCostCodesSuspenseQueryHookResult = ReturnType<typeof useBulkAddItemCostCodesSuspenseQuery>;
export type BulkAddItemCostCodesQueryResult = ApolloReactCommon.QueryResult<BulkAddItemCostCodesQuery, BulkAddItemCostCodesQueryVariables>;